import { HandleAuthTokenRefresh, Timeout } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";

export const HandleAuthTokenRefreshTimer = async() => {
	console.log("HandleAuthTokenRefreshTimer")
	await Timeout(environment.server.accessTokenRefreshMilliseconds);
	console.log("After Timer")
	await HandleAuthTokenRefresh();
}